import React from 'react';
import { Card, CardContent, Typography, Grid, Box } from '@mui/material';

const StatRow = ({ label, value, highlight }) => (
  <Grid
    item
    xs={12}
    sx={{ display: 'flex', justifyContent: 'space-between' }}
  >
    <Typography variant='body2'>{label}</Typography>
    <Typography
      variant='body2'
      sx={{
        color: highlight ? '#F59C1E' : 'inherit',
        fontWeight: 'bold',
      }}
    >
      {value}
    </Typography>
  </Grid>
);

const SummaryCard = ({ data }) => {
  if (!data || !data.month_wise_stats) {
    return (
      <Typography
        variant='body2'
        sx={{ textAlign: 'center', mt: 2 }}
      >
        No data available
      </Typography>
    );
  }

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
      >
        <Card
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography sx={{ fontSize: 20, fontWeight: 'bold' }}>
            {data?.company_name}
          </Typography>
          <Box
            sx={{
              display: 'inline-block',
              padding: '4px 10px',
              borderRadius: '12px',
              backgroundColor:
                data?.status === 'INACTIVE' ? '#F59C1E' : '#079551',
              color: '#fff',
            }}
          >
            {data?.status}
          </Box>
        </Card>
      </Grid>

      <Grid
        item
        xs={12}
        md={4}
      >
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Grid
              container
              spacing={1}
            >
              <StatRow
                label='GST / PAN'
                value={data?.gst_or_pan || 'N/A'}
              />
              <StatRow
                label='District'
                value={data?.district || 'N/A'}
              />
              <StatRow
                label='State'
                value={data?.state || 'N/A'}
              />
              <StatRow
                label='Last Invoicing Date'
                value={data?.last_invoicing_date || 'N/A'}
              />
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      {data.month_wise_stats.map((stats, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          key={index}
        >
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography sx={{ fontSize: 18, fontWeight: '600' }}>
                {stats.month}
              </Typography>
              <Grid
                container
                spacing={1}
              >
                <StatRow
                  label='Total Sale'
                  value={stats.total_sale}
                  highlight
                />
                <StatRow
                  label='Active Influencer'
                  value={`${stats.influencer_stats?.active || '0'} / ${
                    stats.influencer_stats?.total || '0'
                  }`}
                  highlight
                />
                <StatRow
                  label='Influencer Sales'
                  value={stats.influencer_stats?.sales || '0'}
                  highlight
                />
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SummaryCard;
